import React from 'react';
import useAllRtmTimeLog from './useAllRtmTimeLog';


const useGetAllRtmTimeLog = ({ pageNumber, perpageData, searchTerm = "" }: { pageNumber: number; perpageData: number; searchTerm?: string }) => {
  const { RtmTimeLogData, getRtmTimelogData, RtmTimeLogDataLoading } = useAllRtmTimeLog({ pageNumber, perpageData, searchTerm });

  React.useEffect(() => {
    getRtmTimelogData();
  }, [pageNumber, searchTerm]);

  return {
    RtmTimeLogData,
    getRtmTimelogData,
    RtmTimeLogDataLoading,
  };
};

export default useGetAllRtmTimeLog;
